export const Home = {
    Title: {
        '置顶课程': '置頂課程',
        '待办事项': '待辦事項',
        '其他课程': '其他課程',
        '我教的':'我教的',
        '我协助的':'我協助的',
        '我学的':'我學的',
    },
    Handle: {
        '课堂排序': '課堂排序',
        '归档管理': '歸檔管理',
        '创建加入课程': '創建/加入課程',
        '创建课程': '創建課程',
        '编辑课程':'編輯課程',
        '加入课程': '加入課程',
        '查看全部': '查看全部',
        '从示范包创建':'從示範包創建',
        '资料': '資料',
        '忽略': '忽略',
        '已忽略':'已忽略!',
        '个人作业': '個人作業',
        '份作业待批改': '份作業待批改',
        '点击查看更多': '點擊查看更多',
        '收起更多学期':'收起更多學期 ↑',
        '展开更多学期':'展開更多學期 ↓',
    },
    Classroom:{
        "直播中":"直播中",
        "会议上课中":"會議/上課中",
        "上课中":"上課中",
        "会议中":"會議中",
        "您有":"您有",
        "个课堂正在上课":"個課堂正在上課…",
    },
    "首页":"首頁",
    "待办":"待辦",
    "待办事项":"待辦事項",
    "课堂":"課堂",
    "私信":"私信",
    "我的":"我的",
    "发现":"發現",
    "期末突击课":"期末突襲課",
    "不挂科":"不掛科",
    "期末不挂科":"期末不掛科",
    "正在跳转中":"正在跳轉中...",
    "登录中":"登錄中...",
    "待审核":"待審核",
    "已通过":"已通過",
    "已拒绝":"已拒絕",
    "提交报名":"提交報名",
    "报名信息":"報名信息",
    "拒绝":"拒絕",
    "通过":"通過",
    "选择加入的标签":"選擇加入的標簽",
    "课程名称":"課程名稱",
    "立即报名":"立即報名",
    "已报名审核中":"已報名，審核中",
    "您无法重复加入课程":"您無法重復加入課程",
    "审核中":"審核中",
    "被拒绝":"被拒絕",
    "您的报名被拒绝如有疑问请与课程老师联络":"您的報名被拒絕，如有疑問，請與課程老師聯絡",
    "课堂派会根据选择的类型定制课程教学活动模块展示您可手动变更定制结果":"課堂派會根據選擇的類型，定制課程教學活動模塊展示，您可手動變更定制結果",
    "不使用模板":"不使用模板",
    "混合课程":"混合課程",
    "线下课程":"線下課程",
    "在线课程":"在線課程",
    "实验课":"實驗課",
    "社会实践课":"社會實踐課",
    "其他":"其他",
    "选择课程模板":"選擇課程模板",
    "请输入课程介绍":"請輸入課程介紹",
    "要创建":"要創建",
    "吗":"嗎?",
    "开启您的轻松建课之旅":"開啟您的輕松建課之旅。",
    "创建成功":"創建成功",
    "报名设置":"報名設置",
    "审核方式":"審核方式",
    "审核后自动加入标签":"審核後自動加入標簽",
    "默认标签":"默認標簽",
    "报名信息收集":"報名信息收集",
    "添加更多报名信息问题":"添加更多報名信息問題",
    "收集信息标题":"收集信息標題",
    "请输入标题":"請輸入標題",
    "自动审核":"自動審核",
    "手动审核":"手動審核",
    "要恢复":"要恢復",
    "您":"您",
    "和您的学生":"和您的學生",
    "可以重新在此课程中互动":"可以重新在此課程中互動",
    "此课程会在课程首页上显示":"此課程會在課程首頁上顯示",
    "取消归档成功":"取消歸檔成功",
    "输入课堂的6位加课码":"輸入課堂的6位加課碼",
    "也可以使用微信扫一扫扫描课堂二维码加入":"也可以使用微信掃壹掃掃描課堂二維碼加入",
    "进入课程":"進入課程",
    "点击返回至首页":"點擊返回至首頁",
    "前往认证":"前往認證",
    "您在这个课程的任何信息或评论将被永久删除":"您在這個課程的任何信息或評論將被永久刪除。",
    "警告此操作无法撤销":"警告: 此操作無法撤銷",
    "继续操作或关闭":"繼續操作或關閉",
    "您可以在我的归档课堂里面查看此课堂":"您可以在“我的-歸檔課堂“裏面查看此課堂",
    "归档自己":"歸檔自己",
    "归档全班":"歸檔全班",
    "要复制":"要復制",
    "请输入新课程名称":"請輸入新課程名稱",
    "复制内容":"復制內容",
    "复制学员":"復制學員",
    "复制助教":"復制助教",
    "复制资料":"復制資料",
    "复制外链":"復制外鏈",
    "确定要转让":"確定要轉讓",
    "此课程的任何信息或评论将被永久转让":"此課程的任何信息或評論將被永久轉讓",
    "请输入转让老师的账号手机号邮箱":"請輸入轉讓老師的賬號/手機號/郵箱",
    "没有找到匹配的结果":"沒有找到匹配的結果",
    "课程排序":"課程排序",
    "搜索我教的课程":"搜索我教的課程",
    "请输入登录密码验证":"請輸入登錄密碼驗證",
    "加课码已重置":"加課碼已重置",
    "确定要删除":"確定要刪除",
    "请按照提示输入":"請按照提示輸入",
    "删除后数据将无法恢复":"刪除後數據將無法恢復！",
    "确定删除":"確定刪除",
    "再想想":"再想想",
    "要归档管理此课程吗":"要歸檔管理此課程嗎",
    "成功":"成功",
    "课程":"課程",
    "确定要退课":"確定要退課",
    "确定复制":"確定復制",
    "请输入课程名":"請輸入課程名",
    "归档成功":"歸檔成功",
    "删除失败":"刪除失敗",
    "请输入要转让的老师的账号":"請輸入要轉讓的老師的賬號",
    "转让成功":"轉讓成功",
    "搜索我学的课程":"搜索我學的課程",
    "前往绑定":"前往綁定",
    "已成功加入":"已成功加入",
    "课堂名称":"課堂名稱",
    "请输入课堂名称":"請輸入課堂名稱",
    "教学班级名称":"教學班級名稱",
    "请输入教学班级名称":"請輸入教學班級名稱",
    "选择学年":"選擇學年",
    "选择学期":"選擇學期",
    "更多信息":"更多信息",
    "请输入大于0的数":"請輸入大於0的數",
    "请输入学时":"請輸入學時",
    "请输入授课地点":"請輸入授課地點",
    "对机构后台可见":"對機構後臺可見",
    "确认":"確認",
    "姓名":"姓名",
    "手机":"手機",
    "学号":"學號",
    "工号":"工號",
    "学校":"學校",
    "公司":"公司",
    "第一学期":"第壹學期",
    "第二学期":"第二學期",
    "请填写课程名称":"請填寫課程名稱",
    "请选择学年":"請選擇學年",
    "请选择学期":"請選擇學期",
    "编辑成功":"編輯成功",
    "创建":"創建",
    "学生需额外补充下列信息才能加入课堂":"學生需額外補充下列信息才能加入課堂",
    "自然班级":"自然班级",
    "入学年月":"入學年月",
    "新建课程": "新建課程",
    "我的课程":"我的課程",
    "课程广场":"課程廣場",
    "我的特权":"我的特權",
    "查看全部待办":"查看全部待辦",
    "暂无待办事项":"暫無待辦事項",
    "玩转课堂派":"玩轉課堂派",
    "推荐课程":"推薦課程",
    "课程筛选":"課程篩選",
    "请选择课程":"請選擇課程",
    "选择课程":"選擇課程",
    "全部课程":"全部課程",
    "教":"教",
    "学":"學",
    "已经全部加载完了，没有更多了":"已經全部加載完了，沒有更多了",
    "最早":"最早",
    "共有":"共有",
    "后可参与评论":"後可參與評論",
    "申请加入虚拟教研室可以继续阅读和名师一起研讨引用优质的教学资源":"申請加入虛擬教研室可以繼續閱讀和名師壹起研討引用優質的教學資源",
    "去评论":"去評論",
    "活动详情":"活動詳情",
    "编辑内容":"編輯內容",
    "教研室公告":"教研室公告",
    "请输入公告内容":"請輸入公告內容",
    "暂无公告内容":"暫無公告內容",
    "公告内容不允许为空":"公告內容不允許為空！",
    "发送申请":"發送申請",
    "请先填写个人信息发送申请发起人审核通过后可以参与虚拟教研室的建设同时还享有":"請先填寫個人信息，發送申請。發起人審核通過後可以 參與虛擬教研室的建設，同時還享有",
    "引用该教研室的资源和共建的样板课程参与培训研讨":"引用該教研室的資源和共建的樣板課程，參與培訓研討",
    "职称":"職稱",
    "请选择职称":"請選擇職稱",
    "申请成功":"申請成功",
    "暂无申请消息":"暫無申請消息",
    "申请时间":"申請時間",
    "处理申请":"處理申請",
    "提交信息":"提交信息",
    "设置身份":"設置身份",
    "内容不允许为空":"內容不允許為空！",
    "引用样板课程新建课程":"引用樣板課程新建課程",
    "教学班级":"教學班級",
    "点击选择学年":"點擊選擇學年",
    "点击选择学期":"點擊選擇學期",
    "引用内容":"引用內容",
    "成绩设置":"成績設置",
    "引用到样板课程":"引用到樣板課程",
    "教研室基本信息":"教研室基本信息",
    "教研室名称":"教研室名稱",
    "教研室封面":"教研室封面",
    "建设范围":"建設範圍",
    "建设内容":"建設內容",
    "发起单位":"發起單位",
    "教研室简介":"教研室簡介",
    "教学主体及目标":"教學主體及目標",
    "教研主体类型":"教研主體類型",
    "学分":"學分：",
    "核心教材":"核心教材：",
    "专业名称":"專業名稱",
    "专业级别":"專業級別",
    "专业简介":"專業簡介",
    "请在PC端添加主题及目标":"請在PC端添加主題及目標",
    "课程列表":"課程列表",
    "专业列表":"專業列表",
    "教学研究改革主题":"教學研究改革主題",
    "教研室主题":"教研室主題",
    "该小节暂无内容":"該小節暫無內容",
    "请在PC端添加章节课程":"請在PC端添加章節課程",
    "引用到":"引用到",
    "已分配占比":"已分配占比",
    "总成绩":"總成績",
    "整课被引用次数":"整課被引用次數",
    "引用课程内容到":"引用課程內容到…",
    "课程目录":"課程目錄",
    "成绩设置考核方案":"成績設置(考核方案)",
    "课程达成度":"課程達成度",
    "暂无试题":"暫無試題",
    "已经向该教研室的管理团队发起申请请耐心等待审核":"已經向該教研室的管理團隊發起申請，請耐心等待審核",
    "查看详情需要加入教研室确认加入":"查看詳情需要加入教研室，確認加入？",
    "最新活动":"最新活動",
    "更多":"更多",
    "人在讨论":"人在討論",
    "全部动态":"全部動態",
    "赞了我的":"贊了我的",
    "研讨会议":"研討會議",
    "样板课程":"樣板課程",
    "个研讨":"個研討",
    "个动态":"個動態",
    "个成员":"個成員",
    "我创建的":"我創建的",
    "我参与的":"我參與的",
    "按创建时间":"按創建時間",
    "按名称":"按名稱",
    "回放":"回放",
    "图形验证码":"圖形驗證碼",
    "短信验证码":"短信驗證碼",
    "发送验证码":"發送驗證碼",
}
